import WithoutText from './variants/WithoutText'
import WithText from './variants/WithText'

export { default } from './StepChartBlock'

// TODO: Replace all names with the corresponding backend variant names.

export const variants = {
  WithoutText: WithoutText,
  WithText: WithText,
}
